 
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DeleteScheduledMaintenanceState } from '../../actions/types/schedule-maintenance/DeleteScheduledMaintenanceTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: DeleteScheduledMaintenanceState = {
  isLoading: true,
  isTrackerLoading: true,
  iseventDetailsLoading: true,
  success: false,
  errorDeleteMessage: '',
  DeleteScheduledMaintenanceDetails: []
};

/**
 * delete metric summary Slice to delete metric
 */
export const deleteScheduledMaintenanceSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    deleteScheduledMaintenanceStarted: (state) => {
      state.isLoading = true;
    },

    deleteScheduledMaintenanceSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.success = true;
      state.errorDeleteMessage = '';
      state.DeleteScheduledMaintenanceDetails = action.payload;
    },

    deleteScheduledMaintenanceFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorDeleteMessage = action.payload;
      state.DeleteScheduledMaintenanceDetails =
        initialState.DeleteScheduledMaintenanceDetails;
    },

    clearScheduledMaintenance: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorDeleteMessage = '';
      state.DeleteScheduledMaintenanceDetails =
        initialState.DeleteScheduledMaintenanceDetails;
    }
  }
});

export const {
  deleteScheduledMaintenanceStarted,
  deleteScheduledMaintenanceSuccess,
  deleteScheduledMaintenanceFail,
  clearScheduledMaintenance
} = deleteScheduledMaintenanceSlice.actions;
export default deleteScheduledMaintenanceSlice.reducer;
